import { Link } from "react-router-dom";
import { Instagram, Youtube } from "lucide-react";

const LOGO_DARK_BG = "https://customer-assets.emergentagent.com/job_agency-build-v1-1/artifacts/3z4djlb0_Mint%20Muse%20logo%202a.png";

const SOCIAL_LINKS = [
  { icon: Instagram, href: "https://www.instagram.com/mintmusedigital/", label: "Instagram" },
  { icon: Youtube, href: "https://www.youtube.com/@MintMuseDigital", label: "YouTube" },
];

const FOOTER_LINKS = [
  { label: "Services", href: "/services" },
  { label: "Contact", href: "/contact" },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-dark_base text-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        {/* Giant Brand Name */}
        <div className="mb-16">
          <img
            src={LOGO_DARK_BG}
            alt="Mint Muse Digital"
            className="h-16 md:h-24 w-auto object-contain mb-6"
          />
          <p className="font-body text-cream/50 max-w-md text-sm leading-relaxed">
            Mint revenue from premium social media strategies and systems.
          </p>
        </div>

        {/* Links + Social */}
        <div className="flex flex-col md:flex-row justify-between items-start gap-12 pb-16 border-b border-white/10">
          <div className="flex flex-wrap gap-x-10 gap-y-4">
            {FOOTER_LINKS.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                data-testid={`footer-link-${link.label.toLowerCase().replace(/\s/g, '-')}`}
                className="text-cream/60 hover:text-cream text-sm font-body transition-colors duration-300"
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="flex gap-6" data-testid="footer-social-links">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.label}
                href={social.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`social-link-${social.label.toLowerCase()}`}
                aria-label={social.label}
                className="text-cream/50 hover:text-cream transition-opacity duration-300"
              >
                <social.icon size={20} />
              </a>
            ))}
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-cream/30 text-xs font-body">
            &copy; {new Date().getFullYear()} Mint Muse Digital. All rights reserved.
          </p>
          <div className="flex gap-6">
            <span className="text-cream/30 text-xs font-body">Privacy Policy</span>
            <span className="text-cream/30 text-xs font-body">Terms of Service</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
